module.exports = __webpack_public_path__ + "static/media/chargixpro-4.1791841e.jpg";